/* eslint-disable space-before-function-paren */
import { HTTP, DefaultErrorHandler } from "@/utils/http-common"

export default {
  list($, company) {
    return new Promise((resolve, reject) => {
      HTTP.get("/projects/manage/bnc/dataset/")
        .then(r => {
          resolve(r)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  get_informations($, name) {
    return new Promise((resolve, reject) => {
      HTTP.get("/datastore/dataset/manage/" + name + "/")
        .then(r => {
          resolve(r)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  get($, name, params, headers) {
    const p =
      "?" +
      $.lo.join(
        $.lo.map(params, (o, i) => {
          return i + "=" + (typeof o === "object" ? JSON.stringify(o) : o)
        }),
        "&"
      )
    return new Promise((resolve, reject) => {
      HTTP.get(
        "/v1/dataset/" + name + "/" + (p.replace("?", "") ? p : ""),
        headers
      )
        .then(r => {
          resolve(r)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  update($, datasetName, rowToEdit, fields) {
    return new Promise((resolve, reject) => {
      let keys = {}
      keys = $.lo.join(
        $.lo.map($.lo.filter(fields, { primary_key: true }), (c, i) => {
          return `${c.name}=${rowToEdit[c.name]}`
        }),
        ","
      )
      HTTP.post(
        "/v1/dataset/" + datasetName + "/by_id/" + keys + "/",
        rowToEdit
      )
        .then(response => {
          // $.$store.commit("success", "Information mise a jour")
          resolve(response)
        })
        .catch(error => {
          $.$store.commit("error", {
            msg: "Update failed",
            color: "error"
          })
          reject(error)
        })
    })
  },
  create($, datasetName, row) {
    return new Promise((resolve, reject) => {
      HTTP.post("/v1/dataset/" + datasetName + "/", row)
        .then(response => {
          // $.$store.commit("success", "New entry created")
          resolve(response)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  deleteRow($, datasetName, rowToDelete, colums) {
    let keys = {}
    keys = $.lo.join(
      $.lo.map($.lo.filter(colums, { primary_key: true }), (c, i) => {
        return `${c.name}=${rowToDelete[c.name]}`
      }),
      ","
    )

    return new Promise((resolve, reject) => {
      HTTP.delete("/v1/dataset/" + datasetName + "/by_id/" + keys + "/")
        .then(response => {
          $.$store.commit("success", "Data deleted")
          resolve(response)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  truncate($, id) {
    return new Promise((resolve, reject) => {
      if (
        confirm(
          "Etes vous sure de vouloir tronquer ce dataset ? (Cette opération est irréversible)"
        )
      ) {
        HTTP.get("/datastore/dataset/manage/" + id + "/truncate")
          .then(r => {
            $.$store.commit("success", "Dataset tronqué")
            resolve(r)
          })
          .catch(e => DefaultErrorHandler(e, reject))
      } else {
        reject(new Error("Non confirmé"))
      }
    })
  },
  download($, id, name, filters = "") {
    return new Promise((resolve, reject) => {
      HTTP.get("/v1/dataset/" + id + "/export/" + filters)
        .then(r => {
          const uri = encodeURI("data:text/csv;charset=utf-8," + r.data)
          const link = document.createElement("a")
          link.setAttribute("href", uri)
          link.setAttribute(
            "download",
            (name || id).toUpperCase() +
              "_" +
              new Date().toISOString().slice(0, 19) +
              ".csv"
          )
          link.click()
          $.$store.commit("success", "Dataset downloaded")
          resolve(link)
        })
        .catch(e => DefaultErrorHandler(e, reject))
    })
  }
}
